module.exports = __webpack_public_path__ + "static/img/CR.d4bdebe4.png";